import SVG from './SVG'
import * as T from './types'

const Email = (props: T.ISVGProps) => (
  <SVG
    {...props}
    viewBox="0 0 20 16"
    d="M2 0H18C19.1046 0 20 0.89543 20 2V14C20 15.1046 19.1046 16 18 16H2C0.89543 16 0 15.1046 0 14V2C0 0.89543 0.89543 0 2 0ZM11.65 11.45L18 7V4.9L10.65 10.05C10.2591 10.3213 9.74087 10.3213 9.35 10.05L2 4.9V7L8.35 11.45C9.34095 12.1427 10.659 12.1427 11.65 11.45Z"
    fillRule="evenodd"
    clipRule="evenodd"
  />
)

export default Email
